import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from 'react-query';
import { HelmetProvider } from 'react-helmet-async';
import { queryClient } from '@config';
import App from './App';
import './styles';
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <GoogleOAuthProvider clientId="654927993902-36njct2nojdt270kj20uborq23glakq8.apps.googleusercontent.com">
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <React.StrictMode>
          <HelmetProvider>
            <App />
          </HelmetProvider>
        </React.StrictMode>
      </BrowserRouter>
    </QueryClientProvider>
  </GoogleOAuthProvider>,
);
